// @flow
import React from 'react';
import Dropzone from 'react-dropzone';

import { toastr } from 'react-redux-toastr';
import styles from './attachments.scss';

type Props = {
  setUploadFilesSelected: Function,
  loadedFileName?: string,
  heading?: string,
  dropzoneWrapperStyle?: string,
  attachmentModalWrapper?: string,
  attachmentWrapper?: string,
  attachmentFor?: string,
  textDialogWrapperStyle?: string,
  removeAttachedFile: Function,
  accept?: string
};

class Attachments extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.updateFilesToUpload = this.updateFilesToUpload.bind(this);
    this.fileRejectionToastr = this.fileRejectionToastr.bind(this);
  }

  updateFilesToUpload(files: Array) {
    // console.log(files, files[0], new File("x", files[0].name));
    this.props.setUploadFilesSelected(files, this.props.attachmentFor);
  }

  removeAttachedFile(e) {
    // console.log(e, e.target);
    e.stopPropagation();
    this.props.removeAttachedFile(this.props.attachmentFor);
  }

  displayFileSize(size: number) {
    if (size <= 1024) {
      return `${size} bytes`;
    }
    if (size > 1024 && size < 1000000) {
      return `${parseFloat(Math.round(size / 1024)).toFixed(2)} KB`;
    }

    return `${parseFloat(Math.round(size / 1000000)).toFixed(2)} MB`;
  }

  handleFileUpload(event: Object) {
    Array.from(event.target.files).forEach(file =>
      this.props.setUploadFilesSelected(file)
    );
  }

  fileRejectionToastr() {
    const toastrOptions = {
      timeOut: 4000,
      component: (
        <div>
          <h2>Caution!</h2>
          <h3>
            {
              '  File of size above 5MB is not accepted. Please select files of smaller size.'
            }
          </h3>
        </div>
      )
    };

    toastr.error('', toastrOptions);
  }

  render() {
    return (
      <div
        className={`${styles.attachmentModalWrapper} ${this.props.attachmentModalWrapper}`}
      >
        <div className={`${styles.headingAttachmentText}`}>
          {this.props.heading || 'Upload files'}
        </div>
        <div className="">
          <div
            className={`${styles.attachmentWrapper} flex-100 ${this.props.attachmentWrapper}`}
          >
            <div className="j-center">
              <Dropzone
                className={`${styles.dropzoneWrapper} ${this.props.dropzoneWrapperStyle}`}
                onDrop={files => {
                  this.updateFilesToUpload(files);
                }}
                multiple={true}
                disablePreview={false}
                maxSize={5e6}
                onDropRejected={() => {
                  this.fileRejectionToastr();
                }}
                accept={this.props.accept}
              >
                {() => (
                  <div
                    className={`${styles.filesWrapper} ${this.props.fileNameWrapper} l-row j-space-bet`}
                  >
                    <div>
                      {this.props.loadedFileName ? (
                        this.props.loadedFileName
                      ) : (
                        <span
                          className={`${styles.textDialogWrapper} ${this.props.textDialogWrapperStyle} l-row j-center `}
                        >
                          Click to upload or drag and drop
                        </span>
                      )}
                    </div>
                    <div className={this.props.crossButtonWrapper}>
                      {this.props.loadedFileName ? (
                        <button onClick={e => this.removeAttachedFile(e)}>
                          X
                        </button>
                      ) : null}
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Attachments;
